<!-- Table UI Skeleton Loader Data -->
<div *ngIf="isTable === 'TABLE'">
  <table class="table table-hover" aria-describedby="">
    <tbody>
      <tr *ngIf="notFoundData">
        <td class="notfound" [attr.colspan]="colspan" style="text-align: center;">
          <div class="notfound-container">
            <img src="assets/images/notfound.png" alt="No Data Found" 
            class="notfound-img" style="width: auto;max-width: 100px;" />
            <p class="notfound-text">{{ getDisplayMessage() }}</p>
          </div>
        </td>
      </tr>
    </tbody>

  </table>
  <ngx-skeleton-loader *ngIf="isLoading" count="6" animation="true" [theme]="{
      height: isWidth
    }"></ngx-skeleton-loader>
</div>

<!-- Address Skeleton Loader Data -->
<div *ngIf="isTable === 'ADDRESS'">
  <table class="table table-hover" aria-describedby="">
    <tbody>
      <!-- <tr *ngIf="notFoundData">
        <td class="notfound" style="text-align: center;" [innerHtml]="getDisplayMessage()" 
        [attr.colspan]="colspan">
        </td>
      </tr> -->

      <tr *ngIf="notFoundData">
        <td class="notfound" [attr.colspan]="colspan" style="text-align: center;">
          <div class="notfound-container">
            <img src="assets/images/notfound.png" alt="No Data Found" 
            class="notfound-img" style="width: auto;max-width: 100px;" />
            <p class="notfound-text">{{ getDisplayMessage() }}</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
  <div class="fb-item" *ngIf="isLoading">
    <div class="first-section-wrapper">
      <div class="gravatar-title">
        <div>
          <ngx-skeleton-loader [theme]="{
              width: '200px',
              'border-radius': '0',
              height: '25px',
              'margin-bottom': '10px'
            }"></ngx-skeleton-loader>
        </div>
        <div>
          <ngx-skeleton-loader [theme]="{ width: '170px', 'border-radius': '0', height: '23px' }"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    <div style="margin-top: 0px;" class="second-section-wrapper">
      <div class="wrapper">
        <ngx-skeleton-loader [theme]="{
            width: '50%',
            'border-radius': '0',
            'margin-left': '10px',
            height: '15px',
            'margin-bottom': '10px'
          }"></ngx-skeleton-loader>
      </div>
      <div class="wrapper">
        <ngx-skeleton-loader [theme]="{
            width: '40%',
            'border-radius': '0',
            'margin-left': '10px',
            height: '15px',
            'margin-bottom': '10px'
          }"></ngx-skeleton-loader>
      </div>
      <div class="wrapper">
        <ngx-skeleton-loader [theme]="{
            width: '30%',
            'border-radius': '0',
            'margin-left': '10px',
            height: '15px',
            'margin-bottom': '10px'
          }"></ngx-skeleton-loader>
      </div>
    </div>
  </div>
</div>

<!-- Commented ImageBOx section remains unchanged -->
<!-- <div *ngIf="ImageBOx">
  <ngx-skeleton-loader
    count="5"
    appearance="circle"
    [theme]="{
      width: '70px',
      height: '70px',
      'border-radius': '10px'
    }"
  ></ngx-skeleton-loader>
</div> -->